module.exports = __webpack_public_path__ + "img/top_bg1.748880e5.png";